import SectorDiversificationContainer from "./SectorDiversificationContainer";
import SectorDiversificationStore from "./SectorDiversificationStore";

export default SectorDiversificationStore(SectorDiversificationContainer);